import { useNotificationPreferenceText } from '@seek/hirer-notification-preference';
import { useTranslations } from '@vocab/react';
import { Inline, Text } from 'braid-design-system';
import React from 'react';
import { useSelector } from 'react-redux';

import type { AppState } from 'src/types/appState';

import translations from './.vocab';

export const CurrentNotificationPreference = () => {
  const notificationPreference = useSelector(
    (state: AppState) =>
      state.session.notificationsSetting.savedNotificationPreference,
  );
  const frequencyText = useNotificationPreferenceText({
    preference: notificationPreference,
  });
  const { t } = useTranslations(translations);
  return frequencyText ? (
    <Inline space="xxsmall">
      <Text tone="secondary" baseline={false}>
        {t('current-notification-preference-frequency-text')}
      </Text>
      <Text weight="strong" baseline={false}>
        {frequencyText}
      </Text>
    </Inline>
  ) : (
    <></>
  );
};
